import {useEffect, useState} from "react";
import axiosInstance from "../../utils/axiosInstance";
import {IoArrowBackSharp} from "react-icons/io5";
import Loader from "../../components/Loader";

const ApplicationConfiguration = () => {
    const [bannerText, setBannerText] = useState("");
    const [uploaderText, setUploaderText] = useState("");
    const [minDtcPrice, setMinDtcPrice] = useState("");
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchConfiguration = async () => {
            try {
                const response = await axiosInstance.get("/application-configuration");
                setBannerText(response.data?.header_banner_text || "");
                setUploaderText(response.data?.uploader_text || "");
                setMinDtcPrice(response.data?.min_dtc_price?.toString() || "");
            } catch (error) {
                console.error("Failed to load configuration", error);
                setMessage("Failed to load current configuration.");
            } finally {
                setLoading(false);
            }
        };

        fetchConfiguration();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");

        const minDtcPriceInt = parseInt(minDtcPrice, 10);
        if (isNaN(minDtcPriceInt) || minDtcPriceInt < 0) {
            setMessage("❌ Min DTC Price must be a non-negative integer.");
            setLoading(false);
            return;
        }

        try {
            await axiosInstance.post("/application-configuration", {
                header_banner_text: bannerText,
                uploader_text: uploaderText,
                min_dtc_price: minDtcPriceInt,
            });
            setMessage("✅ Updated successfully!");
        } catch (error) {
            console.error("Update failed", error);
            setMessage("❌ Failed to update.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <Loader/>;
    }

    return (
        <div className="mx-auto mt-10 max-w-xl p-6 rounded-[22px] border border-gray-200 bg-white shadow-lg shadow-gray-900/5 dark:border-[#2c2c2e] dark:bg-[#1c1c1e] dark:shadow-black/40">
            <h3 className="mb-1 flex items-center gap-3 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                <button
                    onClick={() => window.history.back()}
                    className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-gray-300 text-gray-500 transition hover:border-red-400/60 hover:text-red-500 dark:border-[#3a3a3d] dark:text-slate-400"
                >
                    <IoArrowBackSharp size={24}/>
                </button>
                <span className="h-6 w-1.5 shrink-0 rounded-full bg-gradient-to-b from-red-500 to-orange-400" />
                Configuration
            </h3>
            <form onSubmit={handleSubmit}>
                <label className="mb-1.5 block text-xs font-bold uppercase tracking-[0.08em] text-gray-500 dark:text-slate-400">
                    Banner Text:
                </label>
                <textarea
                    value={bannerText}
                    onChange={(e) => setBannerText(e.target.value)}
                    rows={4}
                    className="h-11 w-full rounded-[12px] border border-gray-300 bg-white px-4 text-sm text-gray-800 outline-none transition placeholder:text-gray-400 focus:border-red-400 focus:ring-4 focus:ring-red-500/10 disabled:opacity-60 dark:border-[#3a3a3d] dark:bg-[#262628] dark:text-slate-100 dark:placeholder:text-slate-500 mb-4"
                />

                <label className="mb-1.5 block text-xs font-bold uppercase tracking-[0.08em] text-gray-500 dark:text-slate-400">
                    Uploader Text:
                </label>
                <textarea
                    value={uploaderText}
                    onChange={(e) => setUploaderText(e.target.value)}
                    rows={4}
                    className="h-11 w-full rounded-[12px] border border-gray-300 bg-white px-4 text-sm text-gray-800 outline-none transition placeholder:text-gray-400 focus:border-red-400 focus:ring-4 focus:ring-red-500/10 disabled:opacity-60 dark:border-[#3a3a3d] dark:bg-[#262628] dark:text-slate-100 dark:placeholder:text-slate-500 mb-4"
                />

                <label className="mb-1.5 block text-xs font-bold uppercase tracking-[0.08em] text-gray-500 dark:text-slate-400">
                    Min DTC Price:
                </label>
                <input
                    type="number"
                    min="0"
                    value={minDtcPrice}
                    onChange={(e) => setMinDtcPrice(e.target.value)}
                    className="h-11 w-full rounded-[12px] border border-gray-300 bg-white px-4 text-sm text-gray-800 outline-none transition placeholder:text-gray-400 focus:border-red-400 focus:ring-4 focus:ring-red-500/10 disabled:opacity-60 dark:border-[#3a3a3d] dark:bg-[#262628] dark:text-slate-100 dark:placeholder:text-slate-500 mb-4"
                />

                <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex h-11 items-center justify-center gap-2 rounded-full bg-gradient-to-r from-red-600 to-orange-500 px-6 text-sm font-bold text-white shadow-lg shadow-red-500/25 transition hover:from-red-500 hover:to-orange-400 disabled:cursor-not-allowed disabled:opacity-60"
                >
                    {loading ? "Saving..." : "Save"}
                </button>
            </form>

            {message && <div className="mt-4 text-sm text-gray-800">{message}</div>}
        </div>
    );
};

export default ApplicationConfiguration;
